import React, {Component } from "react";
import { withRouter } from "react-router-dom";
import { AvForm, AvField} from "availity-reactstrap-validation";
import {
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Button,
} from "reactstrap";
//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert";
//Import actions redux
import { createParameter } from "../../store/actions";
import { connect } from "react-redux";
//i18n
import { withNamespaces } from "react-i18next";



class CreateComponentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
      popup: false,
      pop_msg: null,
      pop_err: null,
    };
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
    this.handleChangePlcType=this.handleChangePlcType.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.loadingCreatePARAM === false && prevProps.loadingCreatePARAM === true) {
      let msg = this.props.messagePARAM;
      let err = this.props.creationPARAMError;
      if (msg) {
        this.setState({
          popup: true,
          pop_msg: "Paràmetro creado correctamente",
        });
      } else if (err) {
        this.setState({
          popup: true,
          pop_err: "No se ha podido crear el parámetro",
        });
      }
    }
  } //Falta loader de carga mientras se genera el usuario

  // handleValidSubmit
  handleValidSubmit(event, values) {
    let user = this.state.user;
    values["username"] = user.name
    values["token"] = user.token;
    console.log(values)
    this.props.createParameter(values, this.props.history);
  }

  confirmPopup() {
    this.setState({ popup: false });
    this.props.history.push("/parameters");
  }

handleChangePlcType(event){
    this.setState({plcType:event.value})
}

  render() {
    return (
      <React.Fragment>
        <Col lg="12">
          <Card>
            <CardBody>
              <CardTitle className="mb-4">
                {this.props.t("Crear nuevo parámetro")}
              </CardTitle>

              <AvForm
                className="needs-validation"
                onValidSubmit={this.handleValidSubmit}
            
              >
                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom01">
                      {this.props.t("Ip del parámetro")}
                    </Label>
                    <AvField
                      name="ip"
                      placeholder="X.X.X.X"
                      type="text"
                      errorMessage={this.props.t("Introduzca una Ip válida")}
                      className="form-control"
                      validate={{ required: { value: true } }}
                      id="validationCustom01"
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom02">
                    {this.props.t("Puerto del parámetro")}
                    </Label>
                    <AvField
                      name="port"
                      placeholder="xxxx"
                      type="number"
                      errorMessage={this.props.t("Introduzca un puerto válido")}
                      className="form-control"
                      validate={{ required: { value: true } }}
                      id="validationCustom02"
                    />
                  </FormGroup>
                </Col>
                
               
            
               
                <Button color="primary" type="submit">
                  {this.props.t("Crear parámetro")}
                </Button>
              </AvForm>

              {this.state.popup ? (
                <SweetAlert
                  type={this.state.pop_msg ? "success" : "error"}
                  title={
                    this.state.pop_msg ? this.state.pop_msg : this.state.pop_err
                  }
                  confirmBtnText={this.props.t("ok")}
      
                  onConfirm={() => this.confirmPopup()}
                ></SweetAlert>
              ) : null}
            </CardBody>
          </Card>
        </Col>
      </React.Fragment>
    );
  }
}

const mapStateprops = (state) => {
  const { creationPARAMError, messagePARAM, loadingCreatePARAM } = state.createPARAM
  return { creationPARAMError, messagePARAM, loadingCreatePARAM};
};
export default withRouter(
  connect(mapStateprops, {createParameter})(
    withNamespaces()(CreateComponentForm)
  )
);
